import { useLearningProgress } from './useLearningProgress';
import { useLearnerProfile } from './useLearnerProfile';
import type { CourseIdType } from '@/domain/precon-supporter/value-objects/CourseId';

/**
 * 現在のコースに応じた進捗情報を返すカスタムフック
 *
 * @param courseId - コースID ('basic' | 'advanced')
 * @returns 進捗情報とアクセス権限
 */
export const useCurrentCourseProgress = (courseId: CourseIdType) => {
  const basicProgress = useLearningProgress('basic');
  const advancedProgress = useLearningProgress('advanced');
  const { profile: learnerProfile } = useLearnerProfile();

  // 現在のコースに応じた進捗を使用
  const currentProgress =
    courseId === 'basic' ? basicProgress : advancedProgress;

  // アドバンスト編にアクセス可能か判定（基礎編テスト合格 && アドバンスト編受講希望）
  const canAccessAdvancedCourse =
    basicProgress.hasPassedExamination() &&
    (learnerProfile?.getWantsAdvancedCourse() ?? false);

  return {
    ...currentProgress,
    canAccessAdvancedCourse,
    // 基礎編のテスト合格状態は常にアクセス可能にする
    hasPassedBasicExamination: basicProgress.hasPassedExamination,
  };
};
